import { useEffect } from "react";

/** Per-page SEO: unique title + meta description + canonical without extra dependencies. */
export default function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = description;
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = `https://zarcosdecks.com${window.location.pathname === "/" ? "/" : window.location.pathname}`;
    }
  }, [title, description]);
  return null;
}
